import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {normalize} from '../../util/utils';

const viewKey = 'RENAME_DOCUMENT_FROM_BODY';

export default function limitedRiskDocumentsReducer(state = initialState.limitedRiskDocuments, action) {
	switch (action.type) {
		case types.GET_LIMITED_RISK_DOCUMENTS:
			if (action.response && action.response.data) {
				return normalize(action.response.data);
			}
			return state;
		case types.UPDATE_DOCUMENT: {
			if (action.viewKey === viewKey) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.documentId]: {
							...state.byId[action.documentId],
							documentName: action.meta.api.data.documentName
						}
					}
				};
			}
			return state;
		}
		case types.ADD_LIMITED_RISK_DOCUMENT_SIGNOFF: {
			if (action.response && action.response.data) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.response.id]: {
							...[action.response.id],
							approvals: {
								...approvals,
								...action.response
							}
						}
					}
				};
			}

			return state;
		}
		case types.REMOVE_LIMITED_RISK_DOCUMENT_SIGNOFF: {
			if (action.response && action.response.data) {
				return {
					...state,
					byId: {
						...state.byId,
						[action.response.id]: {
							...[action.response.id],
							approvals: approvals.filter((account) => account.id !== action.approvalId)
						}
					}
				};
			}

			return state;
		}
		default:
			return state;
	}
}
